var React = require('react');

function IcClose2 (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Icon/Outlined/Big Close"},React.createElement("path",{"id":"menu / close_big","d":"M9.19429 2L6 5.19429L2.80571 2L2 2.80571L5.19429 6L2 9.19429L2.80571 10L6 6.80571L9.19429 10L10 9.19429L6.80571 6L10 2.80571L9.19429 2Z","fill":"#262626"})));
}

IcClose2.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = IcClose2;

IcClose2.default = IcClose2;
